import { HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, from, switchMap } from "rxjs";

import { OidcSecurityService } from "angular-auth-oidc-client";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private static readonly no_auth_urls: string[] = [
    "rhapsody.onelogin.com/oidc/2/token"
  ];
  private static readonly id_token_urls: string[] = [];


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let tokenSource: Observable<string>;
    console.info(`Intercepting request for ${req.url}`);
    if (AuthInterceptor.no_auth_urls.some((url) => req.url.includes(url))) {
      // Do nothing
      tokenSource = from(['']);
    } else if (
      AuthInterceptor.id_token_urls.some((url) => req.url.includes(url))
    ) {
      tokenSource = inject(OidcSecurityService).getIdToken();
    } else {
      // Default to including the Access token in requests
      tokenSource = inject(OidcSecurityService).getAccessToken();
    }

    return from(
      tokenSource.pipe(
        switchMap((token: string) => {
          if (token) {
            console.info('Adding authorization header');
            const reqWithHeader = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
            return next.handle(reqWithHeader);
          } else {
            console.info('Processing requestg without modification');
            return next.handle(req);
          }
        })
      )
    );
  }
}